import React from 'react'
import { connect } from 'react-redux'
import { StyleSelect } from '@chegg-wt/core/components/StyleSelect'
import { AppState } from '@chegg-wt/core/state'
import { loadStyles, stylesRequested } from '@chegg-wt/core/state/styles/actions'
import { stylesPageSelector, stylesSelector } from '@chegg-wt/core/state/styles/selectors'
import * as Styled from './styled'
import * as TestId from './testIds'
import {
  CitationListCTAProps,
  CitationListCTAStateProps,
  CitationListCTADispatchProps,
} from './types'

type Props = CitationListCTAProps &
  CitationListCTAStateProps &
  CitationListCTADispatchProps

export const CitationListCTAContainer: React.FC<Props> = ({
  copy,
  currentCitationStyle,
  currentCitationStyleName,
  hasCitations,
  setCurrentStyle,
  onClickCreateCitation,
  onClickCopyAllCitations,
  onClickExportCitations,
  ...styleProps
}) => {
  return (
    <Styled.CitationCTAContainer>
      <Styled.CitationButtonCTAContainer>
        <Styled.CreateCitationButton
          size="medium"
          data-test={TestId.CREATE_CITATION_BUTTON}
          onClick={onClickCreateCitation}
        >
          {copy.createCitation}
        </Styled.CreateCitationButton>
        <StyleSelect
          trigger={({ openDropdown, isOpen }) => (
            <Styled.CitationStyleButton
              size="medium"
              onClick={openDropdown}
              data-test={TestId.CHANGE_STYLE_BUTTON}
              aria-expanded={isOpen}
            >
              <>
                <Styled.ButtonText>{currentCitationStyleName}</Styled.ButtonText>
                <Styled.Chevron pointing={isOpen ? 'up' : 'down'} />
              </>
            </Styled.CitationStyleButton>
          )}
          currentStyle={currentCitationStyle}
          currentStyleName={currentCitationStyleName}
          styleSelected={setCurrentStyle}
          dropdownAlignment="left"
          {...styleProps}
        />
      </Styled.CitationButtonCTAContainer>
      {hasCitations && (
        <Styled.CitationUtilityCTAContainer>
          <Styled.CopyButton
            size="medium"
            data-test={TestId.COPY_ALL_BUTTON}
            onClick={onClickCopyAllCitations}
          >
            <>
              <Styled.ImageWrapper>
                <Styled.CopyImage />
              </Styled.ImageWrapper>
              <span>{copy.copyAllCitation}</span>
            </>
          </Styled.CopyButton>
          <Styled.ExportButton
            size="medium"
            data-test={TestId.EXPORT_ALL_BUTTON}
            onClick={onClickExportCitations}
          >
            <>
              <Styled.Export size="medium" />
              <span>{copy.exportAllCitation}</span>
            </>
          </Styled.ExportButton>
        </Styled.CitationUtilityCTAContainer>
      )}
    </Styled.CitationCTAContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  styles: stylesSelector(state),
  stylesPage: stylesPageSelector(state),
})

const mapDispatchToProps = {
  loadStyles,
  stylesRequested,
}

export default connect(mapStateToProps, mapDispatchToProps)(CitationListCTAContainer)
